angular.module('impactx.lot').controller('LotSupplierDetailCtrl', LotSupplierDetailCtrl);
LotSupplierDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$redirect',
    'RedirectAndSaveService',
    'BackFactory',
    'ToolbarService'
];

function LotSupplierDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, $redirect, RedirectAndSaveService, BackFactory, ToolbarService) {
    $scope.oldCompanySelected = null;
    $scope.oldAdminComId = 0;
    var ctrl = this;

    var lotSupplierId = $routeParams.id;
    if (lotSupplierId <= 0) {
        lotSupplierId = BackFactory.getLotSupplierId();
    }
    ctrl.showLotSupplierList = false;

    dataGen.getData($scope, {
        id: lotSupplierId,
        lotId: $routeParams.lotId
    }, "/lot/supplierviewdetail").then(function () {
        defineButtons();
    });

    this.onCompanySelect = function (selected) {
        //last condition means this is the initial load of the dialog where the inputs are already given.
        if (selected && ($scope.oldCompanySelected != selected.id) && $scope.oldCompanySelected != null) {
            var tempScope = {};
            dataGen.getData(tempScope, {
                lotSupplierId: $scope.data.id,
                comId: selected.id
            }, "/lot/suppliercontactandcat").then(function () {
                if (tempScope.data.catalog) {
                    $scope.data.catalog.entries = tempScope.data.catalog.entries;
                    $scope.data.catalog.selected = tempScope.data.catalog.selected;
                }
                else {
                    $scope.data.catalog.selected = {};
                    if ($scope.data.catalog.entries)
                        $scope.data.catalog.entries.length = 0;
                }
                if (tempScope.data.contact1User) {
                    $scope.data.contact1User.entries = tempScope.data.contact1User.entries;
                    $scope.data.contact2User.entries = tempScope.data.contact1User.entries;
                    $scope.data.contact3User.entries = tempScope.data.contact1User.entries;

                    $scope.data.contact1User.selected = tempScope.data.contact1User.selected;
                    $scope.data.contact2User.selected = tempScope.data.contact1User.selected;
                    $scope.data.contact3User.selected = tempScope.data.contact1User.selected;
                }
                else {
                    $scope.data.contact1User.selected = {};
                    $scope.data.contact2User.selected = {};
                    $scope.data.contact3User.selected = {};

                    if ($scope.data.contact1User.entries)
                        $scope.data.contact1User.entries.length = 0;
                    if ($scope.data.contact2User.entries)
                        $scope.data.contact2User.entries.length = 0;
                    if ($scope.data.contact3User.entries)
                        $scope.data.contact3User.entries.length = 0;
                }
                if ($scope.oldAdminComId !== tempScope.data.adminComId) {
                    $scope.data.disRelation.relation.assigned.length = 0;
                }
                $scope.oldAdminComId = tempScope.data.adminComId;
            });
        }
        else {
            if (!selected && $scope.oldCompanySelected != null) {
                $scope.data.catalog.selected = {};
                $scope.data.contact1User.selected = {};
                $scope.data.contact2User.selected = {};
                $scope.data.contact3User.selected = {};

                if ($scope.data.catalog.entries)
                    $scope.data.catalog.entries.length = 0;
                if ($scope.data.contact1User.entries)
                    $scope.data.contact1User.entries.length = 0;
                if ($scope.data.contact2User.entries)
                    $scope.data.contact2User.entries.length = 0;
                if ($scope.data.contact3User.entries)
                    $scope.data.contact3User.entries.length = 0;
            }
            if (selected) {
                $scope.oldAdminComId = $scope.data.adminComId;
            }
            $scope.oldCompanySelected = 0;
        }
    };

    this.onCatalogSelected = function (selected) {
        if (selected) {
            $scope.data.catName.value = selected.value;
        }
    };

    this.saveLotSupplier = function () {
        var dataObj = {
            lotSupplier: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/lot/suppliersave").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };
    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/lot/supplierdelete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.saveAndRedirectLotSubSupplier = function () {
        var dataObj = {
            lot: $scope.data
        };
        dataGen.postAsForm($scope, dataObj, "/lot/suppliersave").then(function () {
            ctrl.redirectLotSubSupplier();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.redirectLotSubSupplier = function () {
        $redirect.redirectTo(null, "/lotsubsupplierlist/" + $scope.data.id);
    };

    this.showLotSubSupplier = function (event) {
        if ($scope.data.readOnly) {
            $redirect.redirectTo(null, "/lotsubsupplierlist/" + $scope.data.id);
        }
        else {
            if ($scope.data.id > 0) {
                RedirectAndSaveService.showRedirectAndSaveDialog(ctrl.saveAndRedirectLotSubSupplier, ctrl.redirectLotSubSupplier, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    false);
            }
            else {
                RedirectAndSaveService.showRedirectAndSaveDialog(ctrl.saveAndRedirectLotSubSupplier, ctrl.redirectLotSubSupplier, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    true);
            }
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.saveLotSupplier,
                type: 'validation',
                //condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && !$scope.data.mainPartReadOnly && $scope.data.id > 0;
    }

    ctrl.toggleLotSupplierList = function()
    {
        ctrl.showLotSupplierList = !ctrl.showLotSupplierList;
    }
}